export function times(amount: number): number[]
export function times<T>(amount: number, callback: (index: number) => T): T[]
export function times<T>(
  amount: number,
  callback?: (index: number) => T
): (T | number)[] {
  const result: (T | number)[] = []
  for (let i = 0; i < amount; i += 1) {
    result.push(callback ? callback(i) : i)
  }

  return result
}
